import { useCallback } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import SocialAccountPropType from "../../../_types/SocialAccount";
import PostPropType from "../../../_types/Post";
import { getSocialProviderBySocialType } from "../../../_utils/socialProvider";
import SnapshotMaker from "./SnapshotMaker";
import SocialAccountsList from "../SocialAccountsList/SocialAccountsList";
import { useState } from "react";

const SnapshotMakerModal = ({
  accounts,
  postsByProvider,
  onClose,
  ...rest
}) => {
  const { t } = useTranslation(["snapshot-maker"]);
  const [selectedAccountId, setSelectedAccountId] = useState();
  const [templateData, setTemplateData] = useState();

  const handleAccountsChange = useCallback(
    (ids) => {
      const id = ids[0];
      const selectedAccount = accounts.find((item) => item.id === id);
      const provider = getSocialProviderBySocialType(
        selectedAccount.social_type
      );
      const postData = postsByProvider[provider];

      setTemplateData({
        name: selectedAccount.name,
        nickname: selectedAccount.nickname ? `@${selectedAccount.nickname}` : "",
        avatarUrl: selectedAccount.image,
        message: postData.message,
        provider,
      });
      setSelectedAccountId(selectedAccount.id);
    },
    [setTemplateData, setSelectedAccountId, accounts, postsByProvider]
  );

  return (
    <Modal
      autoFocus={false}
      returnFocusOnClose={false}
      initialFocusRef={() => null}
      closeOnOverlayClick={false}
      isOpen
      onClose={onClose}
      size="6xl"
      scrollBehavior="inside"
      motionPreset="none"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("name.post_image_maker")}</ModalHeader>
        <ModalBody display="flex" flexDirection="column" alignItems="center">
          <Box width="100%" maxWidth="960px">
            <SnapshotMaker
              {...rest}
              description={t("description.post_to_image")}
              sourceTab={{
                title: t("tab.social_account"),
                content: (
                  <SocialAccountsList
                    selected={selectedAccountId ? [selectedAccountId] : []}
                    accounts={accounts || []}
                    required
                    onChange={handleAccountsChange}
                  />
                ),
              }}
              defaultTemplateData={templateData}
            />
          </Box>
        </ModalBody>
        <ModalCloseButton />
      </ModalContent>
    </Modal>
  );
};

SnapshotMakerModal.propTypes = {
  accounts: PropTypes.arrayOf(SocialAccountPropType).isRequired,
  postsByProvider: PropTypes.shape({
    [PropTypes.string]: PropTypes.shape(PostPropType),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

SnapshotMakerModal.defaultProps = {};

export default SnapshotMakerModal;
